module.exports = __webpack_public_path__ + "media/images/home/concept_scene_1_sp-00f4fa9e78c8a5b0b69397ff59b0539c.png";